// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchUpsell-cls1_v-O","cls2":"SearchUpsell-cls2_NrE SearchUpsell-cls1_v-O"};